import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
let pending = null;

const nameKey = (name) => {
  let n = String(name || '').trim();
  if (n.includes(',')) {
    const [last, first] = n.split(/,(.*)/s);
    n = `${first} ${last}`;
  }
  return n.toLowerCase().split(/\s+/).filter(Boolean).join(' ');
};

const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = axios.get(`${API}/personnel/inactive-labels`)
      .then((r) => { cache = new Set(r.data?.names || []); return cache; })
      .catch(() => { pending = null; return new Set(); });
  }
  return pending;
};

// Returns withInactive(name) => "Name (Inactive)" for Inactive personnel (display only).
export const useInactiveLabels = () => {
  const [keys, setKeys] = useState(cache || new Set());
  useEffect(() => { let on = true; load().then((k) => on && setKeys(k)); return () => { on = false; }; }, []);
  return useCallback((name) => {
    if (!name || /\(Inactive\)\s*$/.test(name)) return name;
    return keys.has(nameKey(name)) ? `${name} (Inactive)` : name;
  }, [keys]);
};
